import { Link } from "react-router-dom";
import CommonButton from "../ui/CommonButton/CommonButton";
import classes from "./Activity.module.css";
import { FaRegSquarePlus } from "react-icons/fa6";
import { useEffect, useState } from "react";
import DocumentBoard from "./DocumentBoard/DocumentBoard";
import axios from "axios";
import { env } from "../../constants/env";

const Activity = () => {
  const [activeTab, setActiveTab] = useState("outgoing");
  const [unreadIncoming, setUnreadIncoming] = useState(0);
  const [unreadOutgoing, setUnreadOutgoing] = useState(0);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const token = localStorage.getItem("formioToken");

  const fetchUnreadCounts = async () => {
    try {
      const res = await axios.get(
        `${env.apiUrl}/api/submissions/unread/count`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setUnreadIncoming(res.data.unreadAsRecipient || 0);
      setUnreadOutgoing(res.data.unreadAsOwner || 0);
    } catch (err) {
      console.error("Failed to fetch unread counts:", err);
    }
  };

  useEffect(() => {
    fetchUnreadCounts();
  }, []);

  return (
    <div className={`${classes.wrapper} mt-3`}>
      <div className="d-flex justify-content-between align-items-center">
        <div className={`${classes.groupButton} btn-group`} role="group">
          <button
            type="button"
            className={`btn ${
              activeTab === "outgoing" ? classes.activeButton : ""
            }`}
            onClick={() => handleTabClick("outgoing")}
          >
            Outgoing
            {unreadOutgoing > 0 && (
              <span className={classes.badge}>{unreadOutgoing}</span>
            )}
          </button>
          <button
            type="button"
            className={`btn ${
              activeTab === "incoming" ? classes.activeButton : ""
            }`}
            onClick={() => handleTabClick("incoming")}
          >
            Incoming
            {unreadIncoming > 0 && (
              <span className={classes.badge}>{unreadIncoming}</span>
            )}
          </button>
        </div>
        <Link to="select-plan">
          <CommonButton
            icon={<FaRegSquarePlus size={18} />}
            text="Create new document"
          />
        </Link>
      </div>
      <div className={`mt-4 ${classes.documentBoard}`}>
        {activeTab === "incoming" && <DocumentBoard type="incoming" />}
        {activeTab === "outgoing" && <DocumentBoard type="outgoing" />}
      </div>
    </div>
  );
};

export default Activity;